import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { SETTINGS } from 'codefoxhucore';
import { DialogService } from 'primeng/dynamicdialog';
import { UsergroupeditorComponent } from '../usergroupeditor/usergroupeditor.component';
import { filter, takeUntil } from 'rxjs/operators';
import { UsergroupdeleteComponent } from '../usergroupdelete/usergroupdelete.component';
import { UserGroup } from '../../interfaces/interfaces';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { refreshTable } from '../../helpers/helper';

@Component({
  selector: 'app-usergroups',
  templateUrl: './usergroups.component.html',
  styleUrls: ['./usergroups.component.scss'],
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UsergroupsComponent extends SimpleTableComponent<UserGroup> {

  showUserGroupEditorModal(userGroup: UserGroup|null = null): void {
    this.dialogService.open(UsergroupeditorComponent, {
      header: userGroup !== null ? 'Felhasználói csoport szerkesztése - ' + userGroup.name : 'Felhasználói csoport hozzáadása',
      data: {
        userGroupId: userGroup !== null ? userGroup.id : null
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      refreshTable(this.table);
    });
  }

  showUserGroupDeleteModal(userGroup: UserGroup|null = null): void {
    if (userGroup === null) {
      return;
    }
    SETTINGS.precheckInterceptorPrecheck = 'ERROR';
    this.apiServiceRef.deleteUserGroup(userGroup.id).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.dialogService.open(UsergroupdeleteComponent, {
        header: 'Felhasználói csoport törlése - ' + userGroup.name,
        data: {
          userGroupId: userGroup.id
        }
      }).onClose.pipe(filter(v => v === true)).subscribe(() => {
        refreshTable(this.table);
      });
    });
  }

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'usergroups';
  }
}
